import {
  Alert,
  AlertDescription,
} from "@arcadeai/design-system/components/ui/atoms/alert";
import { cn } from "@arcadeai/design-system/lib/utils";
import type { OAuthCatalogue } from "@arcadeai/design-system/metadata/types";
import { Lightbulb } from "lucide-react";

type DocsAlertProps = {
  provider: OAuthCatalogue;
  className?: string;
};

export const DocsAlert = ({ provider, className }: DocsAlertProps) => (
  <Alert
    className={cn(
      "border border-white/10 bg-blue-100/80 py-1 dark:border-white/10 dark:bg-zinc-800/60",
      className
    )}
    variant="default"
  >
    <AlertDescription className="flex items-center gap-4 py-2 text-sm">
      <Lightbulb className="size-4 text-blue-500" />
      <span className="text-black dark:text-white">
        Need help with {provider?.name} setup? Visit our{" "}
        <a
          className="pr-0.5 text-link underline hover:text-link/80"
          href={provider?.docs}
          rel="noopener noreferrer"
          target="_blank"
        >
          documentation
        </a>
      </span>
    </AlertDescription>
  </Alert>
);
